import { useDispatch } from 'react-redux';
import useHistory from 'hooks/useHistory';
import ProPageLayout from 'components/ProPageLayout';
import Coupon from 'types/Coupon';
import SignUpForm from 'components/SignUpForm';
import { setUser } from '../../userSlice';

type Props = {
  coupon?: Coupon;
};

export default function RegisterRoute({ coupon }: Props) {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <ProPageLayout>
      <SignUpForm
        handleRegistrationSuccess={({ user }) => {
          dispatch(setUser(user));

          const params = new URLSearchParams(__AT_DATA__.search);

          if (coupon) {
            params.set('k', coupon.code);
          }

          const search = params.toString();

          history.push(`/plus/checkout${search ? `?${search}` : ''}`);
        }}
        useReactRouter
      />
    </ProPageLayout>
  );
}
